import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";
import { chipContainerStyles, tagStyles } from "SharedComponent/styles/sharedStyles";

export const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: "0px 12px 0px 12px",
      height: "100%",
    },
    container: {
      flexDirection: "column",
      height: "100%",
      "& .userItem": {
        width: "100%",
        "&.heading": {
          paddingBottom: theme.spacing(1.5),
          "& p": {
            fontSize: 24,
            color: COLORS.BLACK,
            fontWeight: 600,
          },
        },
        "&.content": {
          backgroundColor: COLORS.WHITE,
          borderRadius: theme.spacing(1),
          height: "calc(100vh - 44px)",
          paddingTop: theme.spacing(1.5),
          "& .hubIdLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
          "& .serviceType": {
            color: "#2D2D2D",
            fontWeight: 500,
            fontSize: 12,
            textTransform: "capitalize",
          },
          '& .panelItem': {
            width: "100%",
            '&.chipFilter': {
              padding: "12px 0px 10px 0px",
              '& .chipsContainer': {
                gap: 8,
                '& .chipFilterItem': {
                  height: 36,
                  minWidth: "11%",
                  borderRadius: theme.spacing(1),
                  border: `1px solid ${COLORS.TRANSPARENT_BLUE_BORDER}`,
                  backgroundColor: COLORS.TRANSPARENT_BLUE,
                  cursor: "pointer",
                  '&:last-child': {
                    marginRight: 0
                  },
                  '&.active': {
                    background: COLORS.AZURE_BLUE,
                    border: "none",
                    boxShadow: "none",
                    '& .chipItem p': {
                      color: COLORS.WHITE
                    }
                  },
                  ...chipContainerStyles(theme)
                }
              }
            },
        }
        },
      },
      
    },
    contentContainer: {
      height: "calc(100vh - 44px)",
      "& .contentItem": {
        height: "100%",
        "&.left": {
          width: "40%",
          paddingRight: theme.spacing(1),
          overflow: "auto",
        },
        "&.right": {
          width: "60%",
          paddingLeft: theme.spacing(1),
          "& .mapRightContainer": {
            height: "100%",
            "&.mapItem": {
              height: "calc(100% - 60px)",
            },
            "&.buttonItem": {
              height: "60px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
          },
        },
      },
    },
    noMapGridContainerViewStyle: {
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: COLORS.LIGHT_GREY,
      borderRadius: theme.spacing(1),
      fontSize: 16,
      color: COLORS.GREY_SCALE,
      flexDirection: 'column',
    },
    searchSectionContainer: {
      width: "auto",
      height: "auto",
      margin: "auto 8px",
    },
    searchSectionlSpanStyle: {
      display: "flex",
      color: COLORS.MINE_SHAFT,
      fontWeight: 400,
      fontSize: 14,
      margin: "auto 0px auto 32px",
    },
    searchSectionBoldSpanStyle: {
      color: COLORS.MINE_SHAFT,
      fontWeight: 600,
      fontSize: 14,
      margin: "auto 0px auto 4px",
    },
    statusHeaderContainer: {
      '& .tag': {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
      },
    },
    driverCountText: {
      textAlign: 'left', 
      width: '100%', 
      display: 'block',
      margin: theme.spacing(0, 0, 0, 2),
      color: COLORS.MINE_SHAFT,
    },
    statusLegend: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: theme.spacing(2),
      margin: theme.spacing(1, 0, 2, 2),
    },
    statusLegendItem: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
    statusCircle: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      display: 'inline-block',
    },
    statusLabel: {
      fontSize: 12,
      color: COLORS.MINE_SHAFT,
      fontWeight: 500,
    },
    filtersContainer: {
      padding: theme.spacing(2, 2),
    },
    legendContainer: {
      marginBottom: theme.spacing(2),
    },
    mapContainer: {
      width: '100%',
      height: 'calc(100vh - 300px)',
      padding: theme.spacing(1, 2),
    },
    mapLoaderContainer: {
      width: '100%',
      height: 'calc(100vh - 300px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    refreshIconContainer: {
      display: 'flex', 
      alignItems: 'flex-end', 
      padding: theme.spacing(2, 2),
      "& .icon": {
        cursor: "pointer",
        verticalAlign: "middle",
        fill: "none",
      },
    },
    refreshIcon: {
      marginLeft: "8px",
      alignSelf: "center",
      cursor: "pointer",
      verticalAlign: "middle",
      fill: "none",
    },
    mapWrapper: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    mapLoadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    },
    title: {
      margin: theme.spacing(2, 0, 0, 2),
      fontWeight: 700,
      fontSize: 24,
      color: COLORS.BLACK,
    },    
    pulseMarker: {
      position: "absolute",
      width: 20,
      height: 20,
      borderRadius: "50%",
      backgroundColor: COLORS.AZURE_BLUE,
      transform: "translate(-50%, -50%)",
      "&::before": {
        content: '""',
        position: "absolute",
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        backgroundColor: COLORS.AZURE_BLUE,
        animation: "$pulse 1.5s ease-out infinite",
        opacity: 0.7,
      },
    },
    dialogHeaderSpanStyle: {
      fontSize: 11,
      fontWeight: 400,
      lineHeight: "normal",
      color: COLORS.MINE_SHAFT,
    },
    dialogValueSpanStyle: {
      fontSize: 14,
      fontWeight: 600,
      lineHeight: "normal",
      color: COLORS.MINE_SHAFT,
      margin: "4px 0px 0px 0px",
    },
    infoWindowCardStyle: {
      padding: theme.spacing(1),
      margin: theme.spacing(0),
    },
    infoWindowCardValueSpanStyle: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "normal",
      color: COLORS.MINE_SHAFT,
      margin: "0px 0px 0px 4px",
    },

    // Map overlay styles
    mapOverlayContainer: {
      position: "relative",
    },
    mapOverlayControls: {
      position: "absolute",
      top: 16,
      left: 16,
      right: 16,
      zIndex: 1000,
      backgroundColor: "white",
      borderRadius: 8,
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
    mapFullHeight: {
      height: "calc(100vh - 180px)",
      position: "relative",
      marginTop: theme.spacing(2),
    },
    driverDetailsCard: {
      position: "absolute",
      top: 200,
      right: 16,
      width: 320,
      maxHeight: "calc(100vh - 400px)",
      backgroundColor: "white",
      borderRadius: 8,
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      padding: theme.spacing(3, 2, 2, 2), // Extra top padding for close button
      zIndex: 1000,
      overflow: "auto",
    },
    driverDetailsHeader: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
      borderBottom: `1px solid ${COLORS.ALTO}`,
      paddingBottom: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
      paddingRight: theme.spacing(4), // Space for close button
    },
    driverAvatar: {
      width: 48,
      height: 48,
      fontSize: 18,
      fontWeight: 600,
      backgroundColor: COLORS.PRIMARY_MAIN,
      color: COLORS.WHITE,
    },
    driverNameContainer: {
      flex: 1,
    },
    driverDetailsTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: COLORS.BLACK,
      marginBottom: theme.spacing(0.5),
    },
    driverDetailsRow: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      marginBottom: theme.spacing(1.5),
      padding: theme.spacing(0.5, 0),
    },
    driverDetailsLabel: {
      fontSize: 10,
      fontWeight: 500,
      color: COLORS.GREY_SCALE,
      textTransform: "uppercase",
      letterSpacing: 0.5,
      marginBottom: theme.spacing(0.25),
    },
    driverDetailsValue: {
      fontSize: 16,
      fontWeight: 600,
      color: COLORS.BLACK,
      lineHeight: 1.2,
    },
    statusBadge: {
      padding: theme.spacing(0.5, 1),
      borderRadius: 16,
      fontSize: 11,
      fontWeight: 600,
      textTransform: "uppercase",
      display: "inline-block",
    },
    consignmentBadge: {
      backgroundColor: '#e3f2fd',
      color: '#1976d2',
      padding: '6px 12px',
      borderRadius: 16,
      fontSize: 12,
      fontWeight: 600,
      cursor: 'pointer',
      border: '1px solid #bbdefb',
      transition: 'all 0.2s ease',
      display: 'inline-block',
      '&:hover': {
        backgroundColor: '#bbdefb',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.2)',
      },
    },
    noAssignments: {
      color: '#999',
      fontStyle: 'italic',
    },
    consignmentContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 8,
    },
    batteryContainer: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      marginTop: theme.spacing(0.5),
    },
    batteryBar: {
      width: 40,
      height: 8,
      backgroundColor: COLORS.LIGHT_GREY,
      borderRadius: 4,
      overflow: "hidden",
    },
    batteryFill: {
      height: "100%",
      borderRadius: 4,
      transition: "width 0.3s ease",
    },
    closeButton: {
      position: "absolute",
      top: 12,
      right: 12,
      width: 28,
      height: 28,
      padding: 0,
      minWidth: 28,
      borderRadius: "50%",
      color: COLORS.GREY_SCALE,
      backgroundColor: "transparent",
      fontSize: 18,
      fontWeight: "bold",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        backgroundColor: COLORS.LIGHT_GREY,
        color: COLORS.BLACK,
      },
    },

    // Hub info window styles
    hubInfoWindow: {
      padding: 12,
      minWidth: 200,
    },
    hubInfoHeader: {
      display: "flex",
      alignItems: "center",
    },
    hubInfoTitle: {
      fontWeight: "bold",
      fontSize: 14,
      color: "#333",
    },

    // Message overlay styles
    messageOverlay: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      padding: 20,
      borderRadius: 8,
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      textAlign: "center",
      zIndex: 1000,
      maxWidth: 300,
    },
    messageOverlayTitle: {
      marginBottom: 8,
      color: "#333",
    },
    messageOverlayText: {
      color: "#666",
    },

    // Error message styles
    errorMessage: {
      position: "absolute",
      top: 20,
      right: 20,
      backgroundColor: "#ffebee",
      color: "#c62828",
      padding: "12px 16px",
      borderRadius: 4,
      border: "1px solid #ffcdd2",
      zIndex: 1000,
    },

    // Keyframes
    "@keyframes pulse": {
      "0%": {
        transform: "scale(1)",
        opacity: 0.7,
      },
      "100%": {
        transform: "scale(2.5)",
        opacity: 0,
      },
    },
  })
);